/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: false, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "Kalp Mehta | Portfolio",
  description:
    "Personal portfolio of Kalp Mehta showcasing technical skills, co-op experience, projects, and achievements across software, data, and intelligent systems.",
  og: {
    title: "Kalp Mehta Portfolio",
    type: "website",
    url: "http://kalpmehta.com/",
  },
};

//Home Page
const greeting = {
  title: "Kalp Mehta",
  logo_name: "Kalp Mehta",
  nickname: "",
  subTitle:
    "A tech geek by curiosity and a builder by nature. I like exploring how things work, experimenting with new technology, and turning interesting problems into projects that I can actually put to use.",
  resumeLink:
    "https://drive.google.com/file/d/1SDmS7Oc1zyR4WGwpKoFSCB4-JGWUnRkJ/view?usp=drive_link",
  portfolio_repository: "https://github.com/Kapp-M",
  githubProfile: "https://github.com/Kapp-M",
};

const socialMediaLinks = [

  {
    name: "Github",
    link: "https://github.com/Kapp-M",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/kalpmehta05/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  {
    name: "Gmail",
    link: "mailto:kalp05mehta@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
  {
    name: "Instagram",
    link: "https://www.instagram.com/thekalpmehta/",
    fontAwesomeIcon: "fa-instagram", // Reference https://fontawesome.com/icons/instagram?style=brands
    backgroundColor: "#E4405F", // Reference https://simpleicons.org/?q=instagram
  },
];

const skills = {
    data: [
        {
            title: "Full-Stack & Software Engineering",
            fileName: "FullStackImg",
            skills: [
                "⚡ Architecting responsive, high-performance web applications using React, TypeScript, and modern JavaScript",
                "⚡ Developing robust backend APIs and microservices using Node.js, C# / .NET, and Python",
                "⚡ Designing scalable relational and NoSQL database schemas with MySQL, PostgreSQL, and MongoDB",
            ],
            softwareSkills: [
                {
                    skillName: "TypeScript",
                    fontAwesomeClassname: "simple-icons:typescript",
                    style: {
                        color: "#3178C6",
                    },
                },
                {
                    skillName: "JavaScript",
                    fontAwesomeClassname: "simple-icons:javascript",
                    style: {
                        backgroundColor: "#000000",
                        color: "#F7DF1E",
                    },
                },
                {
                    skillName: "ReactJS",
                    fontAwesomeClassname: "simple-icons:react",
                    style: {
                        color: "#61DAFB",
                    },
                },
                {
                    skillName: "NodeJS",
                    fontAwesomeClassname: "devicon-plain:nodejs-wordmark",
                    style: {
                        color: "#339933",
                    },
                },
                {
                    skillName: "C#",
                    fontAwesomeClassname: "simple-icons:csharp",
                    style: {
                        backgroundColor: "transparent",
                        color: "#9B4F96",
                    },
                },
                {
                    skillName: "DotNet",
                    fontAwesomeClassname: "simple-icons:dotnet",
                    style: {
                        backgroundColor: "transparent",
                        color: "#512BD4",
                    },
                },
                {
                    skillName: "Python",
                    fontAwesomeClassname: "ion-logo-python",
                    style: {
                        backgroundColor: "transparent",
                        color: "#3776AB",
                    },
                },
                {
                    skillName: "HTML5",
                    fontAwesomeClassname: "simple-icons:html5",
                    style: {
                        color: "#E34F26",
                    },
                },
                {
                    skillName: "CSS3",
                    fontAwesomeClassname: "fa-css3",
                    style: {
                        color: "#1572B6",
                    },
                },
            ],
        },
        {
            title: "Artificial Intelligence & Data Science",
            fileName: "DataScienceImg",
            skills: [
                "⚡ Building and deploying machine learning pipelines, clustering algorithms (DBSCAN), and predictive models",
                "⚡ Integrating Large Language Models (LLMs) and OpenAI APIs for automated intelligence and threat evaluation",
                "⚡ End-to-end model training, evaluation, and production integration using Scikit-Learn, PyTorch, and TensorFlow",
            ],
            softwareSkills: [
                {
                    skillName: "Python",
                    fontAwesomeClassname: "ion-logo-python",
                    style: {
                        backgroundColor: "transparent",
                        color: "#3776AB",
                    },
                },
                {
                    skillName: "TensorFlow",
                    fontAwesomeClassname: "logos-tensorflow",
                    style: {
                        backgroundColor: "transparent",
                    },
                },
                {
                    skillName: "PyTorch",
                    fontAwesomeClassname: "logos-pytorch",
                    style: {
                        backgroundColor: "transparent",
                    },
                },
                {
                    skillName: "Keras",
                    fontAwesomeClassname: "simple-icons:keras",
                    style: {
                        backgroundColor: "white",
                        color: "#D00000",
                    },
                },
                {
                    skillName: "Deeplearning",
                    imageSrc: "deeplearning_ai_logo.png",
                },
            ],
        },
        {
            title: "Data Engineering & Cloud Infrastructure",
            fileName: "CloudInfraImg",
            skills: [
                "⚡ Building reliable ETL data pipelines and managing large-scale data ingestion and transformation",
                "⚡ Optimizing complex SQL queries and database indexes for high-throughput analytical workloads",
                "⚡ Containerizing applications with Docker and deploying modern cloud-based web platforms",
            ],
            softwareSkills: [
                {
                    skillName: "MySQL",
                    fontAwesomeClassname: "simple-icons:mysql",
                    style: {
                        color: "#4479A1",
                    },
                },
                {
                    skillName: "MongoDB",
                    fontAwesomeClassname: "simple-icons:mongodb",
                    style: {
                        color: "#47A248",
                    },
                },
                {
                    skillName: "Docker",
                    fontAwesomeClassname: "simple-icons:docker",
                    style: {
                        color: "#2496ED",
                    },
                },
                {
                    skillName: "Git",
                    fontAwesomeClassname: "simple-icons:git",
                    style: {
                        color: "#F05032",
                    },
                },
            ],
        },
        {
            title: "UI/UX Design & Prototyping",
            fileName: "DesignImg",
            skills: [
                "⚡ Designing intuitive user interfaces and wireframes with Figma and Adobe XD for web and mobile",
                "⚡ Crafting responsive, accessible design systems and user-centric experience flows",
                "⚡ Translating interactive mockups into pixel-perfect frontend React components",
            ],
            softwareSkills: [
                {
                    skillName: "Figma",
                    fontAwesomeClassname: "simple-icons:figma",
                    style: {
                        color: "#F24E1E",
                    },
                },
                {
                    skillName: "Adobe XD",
                    fontAwesomeClassname: "simple-icons:adobexd",
                    style: {
                        color: "#FF2BC2",
                    },
                },
            ],
        },
    ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "LeetCode",
      iconifyClassname: "simple-icons:leetcode",
      style: {
        color: "#F79F1B",
      },
      profileLink: "",
    },
    {
      siteName: "HackerRank",
      iconifyClassname: "simple-icons:hackerrank",
      style: {
        color: "#2EC866",
      },
      profileLink: "",
    },
    {
      siteName: "Codechef",
      iconifyClassname: "simple-icons:codechef",
      style: {
        color: "#5B4638",
      },
      profileLink: "",
    },
    {
      siteName: "Codeforces",
      iconifyClassname: "simple-icons:codeforces",
      style: {
        color: "#1F8ACB",
      },
      profileLink: "",
    },
    {
      siteName: "Hackerearth",
      iconifyClassname: "simple-icons:hackerearth",
      style: {
        color: "#323754",
      },
      profileLink: "",
    },
    {
      siteName: "Kaggle",
      iconifyClassname: "simple-icons:kaggle",
      style: {
        color: "#20BEFF",
      },
      profileLink: "",
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "Conestoga College - School of Applied Science and Technology",
      subtitle: "Bachelors in Computer Science (Honours) — Graduated with Distinction",
      logo_path: "conestoga-logo.png",
      alt_name: "Conestoga College",
      duration: "2022 - 2026",
      descriptions: [
          "⚡ Graduated with Distinction with comprehensive coursework covering Data Structures, Algorithms, Database Management, Operating Systems, Computer Architecture, and Artificial Intelligence.",
          "⚡ Completed advanced courses in Software Development, Full Stack Engineering, and Machine Learning Systems, developing both theoretical understanding and practical skills.",
          "⚡ Engaged in practical projects and collaborative assignments that strengthened problem-solving and software development skills in team settings.",
      ],
          website_link: "https://www.conestogac.on.ca/applied-computer-science-and-information-technology",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: ".NET Full Stack Foundation",
      subtitle: " Board Infinity ",
      logo_path: "board_infinity.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/UQ89W4ND5VMH",
      alt_name: "Stanford University",
      color_code: "#FFFFFF",
    },
    {
      title: "Introduction to Frontend Development",
      subtitle: "- Meta",
      logo_path: "meta.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/SRX9B9T9FRT4",
      alt_name: "deeplearning.ai",
        color_code: "#FAF9F6",
    },
        {
            title: "Introduction to Backend  Development",
            subtitle: "- Meta",
            logo_path: "meta.png",
            certificate_link:
                "https://www.coursera.org/account/accomplishments/verify/YESH7NYHV3YZ",
            alt_name: "deeplearning.ai",
            color_code: "#FAF9F6",
        },
        {
            title: "Principles of UI/UX Design",
            subtitle: "- Meta",
            logo_path: "meta.png",
            certificate_link:
                "https://www.coursera.org/account/accomplishments/verify/A24DEWWXVG4F",
            alt_name: "deeplearning.ai",
            color_code: "#FAF9F6",
        },
        {
            title: "Foundation of Software Testing and Validation",
            subtitle: "- University of Leeds",
            logo_path: "leeds.png",
            certificate_link:
                "https://www.coursera.org/account/accomplishments/verify/44CXXWWGRUUX",
            alt_name: "deeplearning.ai",
            color_code: "#FAF9F6",
        },
        {
            title: "Introduction to Databases",
            subtitle: "- Meta",
            logo_path: "meta.png",
            certificate_link:
                "https://www.coursera.org/account/accomplishments/verify/JZHBYSP2WH8Q",
            alt_name: "deeplearning.ai",
            color_code: "#FAF9F6",
        },
        {
            title: "React Basics",
            subtitle: "- Meta",
            logo_path: "meta.png",
            certificate_link:
                "https://www.coursera.org/account/accomplishments/verify/RQDF6RNWMC25",
            alt_name: "deeplearning.ai",
            color_code: "#FAF9F6",
        },
        {
            title: "Experential Record ",
            subtitle: "- Conestoga College",
            logo_path: "conestoga.png",
            certificate_link:
                "https://mycareer.conestogac.on.ca/ec.htm?r=aWU1RWQvcVpONTg9m",
            alt_name: "deeplearning.ai",
            color_code: "#FAF9F6",
        },
        {
            title: "Programming with JavaScript",
            subtitle: "- Meta",
            logo_path: "meta.png",
            certificate_link:
                "https://www.coursera.org/account/accomplishments/verify/89F8K8EJJ2NX",
            alt_name: "deeplearning.ai",
            color_code: "#FAF9F6",
        },
        {
            title: "Database Structures and Management with MySQL",
            subtitle: "- Meta",
            logo_path: "meta.png",
            certificate_link:
                "https://www.coursera.org/account/accomplishments/verify/9E7JR8ASETN8",
            alt_name: "deeplearning.ai",
            color_code: "#FAF9F6",
        },
       
   
  ],
};

// Experience Page
const experience = {
    title: "Experience",
    subtitle: "Work, Internships and Volunteering",
    description:
        "I have worked across software development, AI, data engineering, and data analytics roles through co-op and industry experiences. Dedicated to building scalable software solutions, intelligent systems, and data-driven impact.",
    header_image_path: "experience.svg",
    sections: [
        {
            title: "Work Experience",
            id: "work-experience",
            work: true,
            experiences: [
                {
                    title: "AI Developer Intern (Co-op)",
                    company: "ProjectTree",
                    company_url: "https://projecttree.ca/",
                    logo_path: "projecttree.png",
                    duration: "Sept 2025 - Dec 2025",
                    location: "",
                    description:
                        "Developed and deployed machine learning and artificial intelligence solutions, integrated automated model pipelines, and optimized system performance for intelligent applications.",
                    color: "#0071C5",
                },
                {
                    title: "Software Developer (Co-op)",
                    company: "Conestoga Entrepreneurship Collective",
                    company_url: "https://www.conestogac.on.ca/entrepreneurship-collective",
                    logo_path: "cec_logo.png",
                    duration: "May 2025 - Aug 2025",
                    location: "Waterloo, ON",
                    description:
                        "Built robust and scalable software solutions for startup initiatives, collaborated on full-stack application development, and delivered core feature enhancements.",
                    color: "#0C9D58",
                },
                {
                    title: "Data Analyst (Part-time)",
                    company: "ProjectTree",
                    company_url: "https://projecttree.ca/",
                    logo_path: "projecttree.png",
                    duration: "Sept 2024 - April 2025",
                    location: "",
                    description:
                        "Conducted comprehensive data analysis, designed interactive dashboards and reporting workflows, and derived actionable insights to guide product and strategic decisions.",
                    color: "#F79F1B",
                },
                {
                    title: "Data Engineer Intern (Co-op)",
                    company: "ProjectTree",
                    company_url: "https://projecttree.ca/",
                    logo_path: "projecttree.png",
                    duration: "May 2024 - Aug 2024",
                    location: "",
                    description:
                        "Constructed reliable ETL pipelines, optimized relational and non-relational database schemas, and streamlined high-throughput data processing workflows.",
                    color: "#4285F4",
                },
                {
                    title: "Technical Support Analyst (Co-op)",
                    company: "ProjectTree",
                    company_url: "https://projecttree.ca/",
                    logo_path: "projecttree.png",
                    duration: "May 2023 - Aug 2023",
                    location: "",
                    description:
                        "Delivered technical support and troubleshooting for software and system workflows, diagnosed technical bottlenecks, and collaborated with engineering teams for rapid resolution.",
                    color: "#181717",
                },
            ],
        },
        {
            title: "Volunteering & Open Source",
            id: "volunteering",
            experiences: [
                {
                    title: "Open Source Contributor",
                    company: "GitHub & Various Organizations",
                    company_url: "https://github.com/",
                    logo_path: "github_logo.png",
                    duration: "2022 - Present",
                    location: "Remote",
                    description:
                        "Contributed to projects from notable organizations, including Google, TensorFlow, and Python Software Foundation, involving bug fixes, feature enhancements, and documentation improvements. Developed skills in collaborative software development and code optimization for large-scale projects.",
                    color: "#181717",
                },
                {
                    title: "Google Developer Student Club Member",
                    company: "Google Developer Student Club",
                    company_url: "https://developers.google.com/community/gdsc",
                    logo_path: "google_logo.png",
                    duration: "2023 - Present",
                    location: "Waterloo, ON",
                    description:
                        "Actively participated in coding workshops and hackathons, assisting peers in coding challenges and facilitating tech events. Supported the club’s community outreach initiatives by helping students enhance their development skills and awareness of industry trends.",
                    color: "#4285F4",
                },
                {
                    title: "Hackathon Participant",
                    company: "Various Hackathons - ConHacks, Seneca Hacks, Indie Game Jam Development",
                    company_url: "https://www.examplehackathon.com/",
                    logo_path: "hackathon_logo.png",
                    duration: "2022 - Present",
                    location: "Various Locations",
                    description:
                        "Collaborated with teams to develop innovative solutions in competitive hackathon environments. These projects honed my problem-solving abilities, teamwork, and application of new technologies under tight deadlines, reinforcing my adaptability and technical knowledge.",
                    color: "#E84A27",
                },
            ],
        },
    ],
};



// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects makes use of vast variety of latest technology tools. My best experience is to create Data Science projects and deploy them to web applications using cloud infrastructure.",
  avatar_image_path: "projects_image.svg",
};

const publicationsHeader = {
  title: "Publications",
  description: "Some of my published Articles, Blogs and Research.",
  avatar_image_path: "projects_image.svg",
};

const publications = {
  data: [
    
  ],
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Get in Touch",
    profile_image_path: "kalp.png",
    description:
      "I’m always open to connecting with fellow developers, tech enthusiasts, and recruiters. Whether you have a question, want to collaborate on a project, or need advice on software development, feel free to reach out! I typically respond within 24 hours and am happy to discuss topics such as Software Development, AI, Mobile Application, and Open Source Contributions.",
  },
  blogSection: {
    title: "Insights & Resources",
    subtitle:
      "Explore my portfolio projects, tutorials, and shared resources on GitHub to see my work, learn more about my technical expertise, and gain insights into industry best practices.",
    link: "https://github.com/Kapp-M", // Link to GitHub as a central resource
    avatar_image_path: "",
  },
  addressSection: {
    title: "Location",
    subtitle: "Ontario, Canada",
    locality: "Waterloo",
    country: "Canada",
    region: "Ontario",
    postalCode: "N2L 0J9",
    streetAddress: "",
    avatar_image_path: "address_image.svg",
    location_map_link: "https://maps.app.goo.gl/V7ZfAk1ycHijeZ9q9",
  },
  phoneSection: {
    title: "Phone",
    subtitle: "+1 (782) 778-0162",
  },
};


export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  publicationsHeader,
  publications,
  contactPageData,
};
